import { render, staticRenderFns } from "./OTSSinVendedor.vue?vue&type=template&id=c00763ea&"
import script from "./OTSSinVendedor.vue?vue&type=script&lang=js&"
export * from "./OTSSinVendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports